export default __webpack_public_path__ + "static/media/sb-ICO-07.872071e6.webp";